// @flow
import styled from "styled-components";
import colors from '../../assets/css/colors';

export const TeamName = styled.p`
	margin-bottom: .5em;
	font-size: 12px;
	font-weight: bold;
	color: ${colors.nrlDarkGreen};
`;

export default TeamName;


// WEBPACK FOOTER //
// ./src/components/PlayersTable/teamName.js